import { BaseModel } from './BaseModel';
import LearningUnitOption from './LearningUnitOption';
import Order from './Order';
// import Order from './Order';

export class OrderItem extends BaseModel {
  static get entity() {
    return 'order_items';
  }
  static get fk() {
    return 'order_item_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      order_id: this.attr(null),
      order: this.belongsTo(Order, 'order_id'),
      // learning_unit_id: this.attr(null),
      // learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      learning_unit_option_id: this.attr(null),
      learning_unit_option: this.belongsTo(LearningUnitOption, 'learning_unit_option_id'),
      mode: this.attr(null),
      price: this.attr(null),
      price_discount: this.attr(null)
    };
  }
  static apiConfig = {
    actions: {
      async fetchItems(params = {}) {
        return this.get(`/order-items`, { params });
      }
    }
  };
}

export default OrderItem;
